import { getSentryInstance } from "./lib/sentry";

export const captureErrorToSentry = (
	error: Error,
	extraData: Record<string, unknown>,
	title?: string,
) => {
	const captureException = getSentryInstance().captureException;

	captureException(error, (scope) => {
		scope.setExtras(extraData);
		if (title) {
			scope.setTransactionName(title);
		}
		return scope;
	});
};

export const captureMessageToSentry = (
	message: string,
	extraData: Record<string, unknown>,
) => {
	const captureMessage = getSentryInstance().captureMessage;
	captureMessage(message, (scope) => {
		scope.setExtras(extraData);

		return scope;
	});
};

export const logApiErrors = (
	query: unknown,
	error: unknown,
	variables?: Record<string, unknown>,
) => {
	const captureException = getSentryInstance().captureException;
	captureException({
		serverError: JSON.stringify(error),
		query: JSON.stringify(query),
		variables: variables ? JSON.stringify(variables) : null,
	});
};

// biome-ignore lint/suspicious/noExplicitAny: register on global for packages/helpers decoupling
(globalThis as any).logApiErrorToSentry = logApiErrors;
